<template>
  <div>
    <div v-show="conShow" style="background: #F5F7F9;height: 800px;overflow-y: auto">
      <div>
        <headMenu @showApply="showApply"></headMenu>
      </div>
      <div>
        <div>
          <img style="width: 100%" src="../assets/news/xw.png" alt="">
        </div>
      </div>
      <div>
        <div class="title">学术诚信</div>
        <div class="defaultSty">
          <div v-for="row in newsOne" class="default-item">
            <div class="item-one" @click="lookDetails(row)">
              <span v-if="row.TITLE.length>14">
                {{row.TITLE.substring(0,14)+'...'}}
              </span>
              <span v-else>
                {{row.TITLE}}
              </span>
            </div>
            <div class="item-two">{{row.ADDTIME}}</div>
          </div>
        </div>
        <div class="title">行业动态</div>
        <div class="defaultSty">
          <div v-for="row in newsTwo" class="default-item">
            <div class="item-one" @click="lookDetails(row)">
              <span v-if="row.TITLE.length>14">
                {{row.TITLE.substring(0,14)+'...'}}
              </span>
              <span v-else>
                {{row.TITLE}}
              </span>
            </div>
            <div class="item-two">{{row.ADDTIME}}</div>
          </div>
        </div>
      </div>
      <div style="height: 45px"></div>
    </div>
    <applyDetails ref="apply" @returnPage="returnPage"></applyDetails>
    <news-details ref="news" @returnPage="returnPage"></news-details>
  </div>
</template>

<script>
import headMenu from "@/head/headMenu.vue";
import applyDetails from "@/head/components/applyDetails.vue";
import NewsDetails from "@/views/components/newsDetails.vue";

export default {
  name: "news",
  components: {NewsDetails, applyDetails, headMenu},
  data() {
    return {
      conShow: true,
      newsOne:[],
      newsTwo:[],
    }
  },
  mounted() {
    window.scroll(0, 0);
    this.conShow = true
    this.axios({
      url: 'https://www.gocheck.cn/newsAction/searchNews.do',//请求地址
      method:'post',//请求方法
      responseType: 'json',//返回值类型
      async: false,
      params: {
        NEWSTYPE: 9,
        newsPage: 1
      }
    }).then(res => {
      console.log(res)//请求成功
      this.newsOne = res.data.articleList
    }).catch(error => {
      console.log(error);//请求失败
    })
    this.axios({
      url: 'https://www.gocheck.cn/newsAction/searchNews.do',//请求地址
      method:'post',//请求方法
      responseType: 'json',//返回值类型
      async: false,
      params: {
        NEWSTYPE: 1,
        newsPage: 1
      }
    }).then(res => {
      console.log(res)//请求成功
      this.newsTwo = res.data.articleList
    }).catch(error => {
      console.log(error);//请求失败
    })
  },
  methods: {
    showApply() {
      this.conShow = false
      this.$refs.apply.init()
    },
    returnPage() {
      this.conShow = true
    },
    lookDetails(row){
      this.conShow = false
      this.$refs.news.init(row)
    }
  }
}
</script>

<style scoped>
.title{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    display: flex;
    padding: 6px 3px;
    margin-left: 2%;
}
.defaultSty{
    position: relative;
    margin: auto;
    background: #FFFFFF;
    border-radius: 5px;
    white-space: break-spaces;
    text-align: left;
    padding: 3%;
}
.default-item{
    font-size: 14px;
    display: flex;
    border-bottom: 1px solid #F5F5F5;
    width:350px;
    line-height: 50px;
    height: 50px;
}
.item-one{
    width: 65%;
}
.item-two{
    margin-left: 22px;
}
</style>